import * as React from 'react';
import cx from 'classnames';
import StringWidget, { stringTemplate } from 'components/StringWidget/StringWidget';
import Loader from 'components/Common/Loader/Loader';
import Button from 'components/Button/Button';
import TextInput from 'components/TextInput/TextInput';
import { makeLoginRequest } from 'actions/LoginSignupActions/loginActions';
import { generateLoginOtp, generateLoginWithOtp } from 'actions/LoginSignupActions/generateLoginOtpActions';
import { reactivateUserAccountAction } from 'actions/LoginSignupActions/reactivateAccountActions';
import { getSignupStatus } from 'actions/LoginSignupActions/signupActions';
import { hideModal } from 'actions/modalActions';
import get from 'lodash/get';
import { isValidMobileNumber, isDigitsOnly, isValidEmail } from 'utils/validators';
import { addClass, removeClass } from 'utils/domHelper';
import { Link } from 'react-router';
import { SIGNUP_URL, ACCOUNT_CHURNED_STATE, ACCOUNT_GUEST_STATE, ACCOUNT_INACTIVE_STATE, ACCOUNT_NOT_FOUND_STATE, ACCOUNT_NOT_VERIFIED_STATE } from 'constants/LoginConstants';
import { getOmnitureLoginId } from '../LoginSignupAnalytics';
import { LOGIN_PAGE_VIEW } from 'constants/LoginConstants';
import { LoginViews } from '../LoginTypes';
import toastConfig from 'toasts.json';
export default class LoginView extends React.Component {
    constructor(props) {
        super(props);
        this.onTextChange = (value) => {
            this.setState(value);
        };
        this.validateAllFields = () => {
            const { userName, password } = this.state;
            let bValid = true;
            const isUserNameDigitsOnly = isDigitsOnly(userName);
            const { pageType, loginSource } = this.props;
            if ((isUserNameDigitsOnly && !isValidMobileNumber(userName)) ||
                (!isUserNameDigitsOnly && !isValidEmail(userName))) {
                this.props.trackOmniture((userName || '').length > 0 ? 'invalid_email_mobile' : '', {
                    pageType,
                    loginSource,
                    loginId: getOmnitureLoginId(userName)
                });
                this.setState({
                    credentialError: <StringWidget strKey="loginInvalidUserName"/>
                });
                bValid = false;
            }
            else if (!password) {
                this.props.trackOmniture('empty_pwd', { pageType, loginSource, loginId: getOmnitureLoginId(userName) });
                this.setState({
                    invalidPassword: <StringWidget strKey="loginInvalidPassword"/>
                });
                bValid = false;
            }
            return bValid;
        };
        this.generateOTP = (accountState, extraParams = {}, trackingStr = 'otp_sent', handleChurnCase = false) => {
            const { userName } = this.state;
            const submitBtn = this.submitContainer;
            const isLoginwithOTP = extraParams.isLoginwithOTP;
            const { handleAPIRequest, changeViewHandler, toast, handleAPIError, styles } = this.props;
            const loginId = isValidMobileNumber(userName) ? `+91${userName}` : userName;
            const _reqBody = isLoginwithOTP
                ? { loginId }
                : `loginId=${loginId}&state=${accountState}&churnEmailRequest=${handleChurnCase}`;
            handleAPIRequest(isLoginwithOTP ? generateLoginWithOtp : generateLoginOtp, _reqBody, payload => {
                // In churned case OTP will be generated with old /api/5 generate api.
                if (accountState === ACCOUNT_CHURNED_STATE && !handleChurnCase) {
                    this.generateOTP(accountState, {
                        mobilePayload: payload,
                        churned: true
                    }, trackingStr, true);
                }
                if (isLoginwithOTP && !extraParams.churned) {
                    const loginWithOTPRequestId = get(payload, 'data.requestId');
                    changeViewHandler({
                        view: LoginViews.LOGIN_WITH_OTP,
                        extra: {
                            userName,
                            loginWithOTPRequestId
                        }
                    });
                }
                else {
                    removeClass(submitBtn, styles['loading']);
                    changeViewHandler({
                        view: LoginViews.VERIFICATION,
                        extra: Object.assign({ userName,
                            payload,
                            accountState, reactivate: accountState === ACCOUNT_INACTIVE_STATE }, extraParams)
                    });
                }
                if (extraParams.churned) {
                    toast.show(toastConfig.verificationCodeSentToAllMsg, {
                        userName,
                        email: get(payload, ['data', 'emailMask'])
                    });
                }
                else if (accountState !== ACCOUNT_CHURNED_STATE) {
                    toast.show(toastConfig.verificationCodeSentMsg, { userName });
                }
            }, payload => {
                let errorPayload = payload;
                if (isLoginwithOTP) {
                    const errorCode = get(payload, 'error.errorCode');
                    const message = get(payload, 'error.message');
                    // convert error payload as per the common login submit error response.
                    errorPayload = {
                        error: {
                            RESPONSE: {
                                errorCode,
                                message
                            }
                        }
                    };
                }
                const errorCode = get(errorPayload, 'error.RESPONSE.errorCode');
                const message = get(errorPayload, 'error.RESPONSE.message');
                if (errorCode === 'LOGIN_1004') {
                    return changeViewHandler({
                        view: LoginViews.MESSAGE_INFO,
                        extra: {
                            message
                        }
                    });
                }
                return handleAPIError(errorPayload);
            }, trackingStr, '', loginId);
        };
        this.onForgotPasswordClick = (userName, e) => {
            e && e.preventDefault();
            const { handleAPIRequest, handleAPIError, trackOmniture, pageType, loginSource } = this.props;
            const loginId = isValidMobileNumber(userName) ? `+91${userName}` : userName;
            handleAPIRequest(getSignupStatus, { loginId: [loginId], supportAllStates: true }, response => {
                const accountState = get(response, ['data', 'userDetails', loginId], '');
                if (accountState === ACCOUNT_NOT_FOUND_STATE || accountState === ACCOUNT_GUEST_STATE) {
                    handleAPIError('loginUnregisteredUserMsg');
                }
                else {
                    trackOmniture('forgot_btn_clicked', { pageType, loginSource, loginId: getOmnitureLoginId(userName) });
                    this.generateOTP(accountState);
                }
            }, handleAPIError);
            return false;
        };
        this.submitContainerRef = (c) => {
            this.submitContainer = c;
        };
        this.handleChangeUserNameClick = () => {
            const { changeViewHandler } = this.props;
            changeViewHandler({
                view: LoginViews.SIGNUP,
                extra: {}
            });
        };
        this.handleSubmit = (e) => {
            const { userName, password, reactivate } = this.state;
            const { handleAPIRequest, handleAPIError, changeViewHandler, styles, handleLoginSuccess, trackOmniture, pageType, loginSource } = this.props;
            const submitBtn = this.submitContainer;
            if (this.validateAllFields()) {
                isValidMobileNumber(userName)
                    ? trackOmniture('login_mobile_entered', { pageType, loginSource })
                    : trackOmniture('login_email_entered', { pageType, loginSource });
                addClass(submitBtn, styles['loading']);
                handleAPIRequest(reactivate ? reactivateUserAccountAction : makeLoginRequest, {
                    loginId: isValidMobileNumber(userName) ? `+91${userName}` : userName,
                    password
                }, () => {
                    removeClass(submitBtn, styles['loading']);
                    handleAPIRequest(hideModal);
                    typeof handleLoginSuccess === 'function' && handleLoginSuccess();
                }, payload => {
                    removeClass(submitBtn, styles['loading']);
                    const errorCode = get(payload, ['error', 'RESPONSE', 'errorCode']);
                    if (errorCode === 'LOGIN_1039') {
                        // Churned account case.
                        changeViewHandler({
                            view: LoginViews.SIGNUP,
                            extra: {
                                oldUserName: userName,
                                churned: true
                            }
                        });
                    }
                    else if (errorCode === 'LOGIN_1032') {
                        // Reactivate case.
                        changeViewHandler({
                            view: LoginViews.LOGIN,
                            extra: {
                                userName,
                                password,
                                disableOTPButton: true,
                                reactivate: true
                            }
                        });
                        trackOmniture('login_deactivated_user', { pageType, loginSource });
                        return this.setState({ reactivate: true, credentialError: '' });
                    }
                    else if (errorCode === 'MAPI_0017') {
                        // Unverified account case.
                        this.generateOTP(ACCOUNT_NOT_VERIFIED_STATE, {
                            password,
                            unverified: true
                        }, 'new_otp_sent');
                        return null;
                    }
                    else if (errorCode === 'LOGIN_1003') {
                        // Signup case.
                        trackOmniture('account_not_exists', { pageType, loginSource, loginId: getOmnitureLoginId(userName) });
                        // When new user tries to login, move them to signup flow with already entered field.
                        changeViewHandler({
                            view: LoginViews.SIGNUP,
                            extra: {
                                mobileNumber: isValidMobileNumber(userName) ? userName : ''
                            }
                        });
                        payload = 'loginUnregisteredUserMsg';
                    }
                    else if (errorCode === 'LOGIN_1012') {
                        // Invalid credentials case.
                        trackOmniture('invalid_login_details', { pageType, loginSource, loginId: getOmnitureLoginId(userName) });
                        this.setState({ credentialError: <StringWidget strKey="loginInvalidCredentials"/> });
                        return null;
                    }
                    else if (errorCode === 'MAPI_0004') {
                        // Already LoggedIn case.
                        typeof handleLoginSuccess === 'function' && handleLoginSuccess();
                    }
                    else if (errorCode === 'LOGIN_1011') {
                        // Invalid login Identifiers case.
                        trackOmniture('invalid_email_mobile', { pageType, loginSource, loginId: getOmnitureLoginId(userName) });
                    }
                    else {
                        trackOmniture('login_failed', { pageType, loginSource });
                    }
                    return handleAPIError(payload);
                }, 'login_success');
            }
            e && e.preventDefault();
            return false;
        };
        this.handleLoginWithOTP = (e) => {
            e && e.preventDefault();
            const { userName, password } = this.state;
            const { pageType, loginSource, handleAPIRequest, changeViewHandler, handleAPIError, trackOmniture } = this.props;
            const isUserNameDigitsOnly = isDigitsOnly(userName);
            if ((isUserNameDigitsOnly && !isValidMobileNumber(userName)) ||
                (!isUserNameDigitsOnly && !isValidEmail(userName))) {
                this.props.trackOmniture((userName || '').length > 0 ? 'invalid_email_mobile' : '', {
                    pageType,
                    loginSource,
                    loginId: getOmnitureLoginId(userName)
                });
                this.setState({
                    credentialError: <StringWidget strKey="loginInvalidUserName"/>
                });
            }
            else {
                const loginId = isValidMobileNumber(userName) ? `+91${userName}` : userName;
                // Check for status call here
                handleAPIRequest(getSignupStatus, { loginId: [loginId], supportAllStates: true }, payload => {
                    const accountState = get(payload, ['data', 'userDetails', loginId], '');
                    if (accountState === ACCOUNT_NOT_FOUND_STATE || accountState === ACCOUNT_GUEST_STATE) {
                        changeViewHandler({
                            view: LoginViews.SIGNUP,
                            extra: {
                                mobileNumber: isValidMobileNumber(userName) ? userName : ''
                            }
                        });
                        handleAPIError('loginUnregisteredUserMsg');
                    }
                    else if (accountState === ACCOUNT_CHURNED_STATE) {
                        changeViewHandler({
                            view: LoginViews.LOGIN,
                            extra: {
                                userName: isValidMobileNumber(userName) ? userName : '',
                                disableOTPButton: true
                            }
                        });
                        handleAPIError('loginChurnedUser');
                    }
                    else if (accountState === ACCOUNT_INACTIVE_STATE) {
                        // Reactivate case, disabled login with OTP.
                        changeViewHandler({
                            view: LoginViews.LOGIN,
                            extra: {
                                userName,
                                password,
                                reactivate: true,
                                disableOTPButton: true
                            }
                        });
                        trackOmniture('login_deactivated_user', { pageType, loginSource });
                        handleAPIError('loginDeactivatedUser');
                        return this.setState({ reactivate: true, credentialError: '' });
                    }
                    else {
                        // generate login with OTP when it is existing account.
                        this.generateOTP(accountState, { isLoginwithOTP: true }, 'login_otp_sent');
                    }
                }, payload => {
                    return handleAPIError(payload, 'login_failed');
                }, 'otp_request_btn_clicked');
            }
        };
        this.handleUserNameChange = (userName) => this.onTextChange({ userName: (userName || '').trim(), credentialError: '' });
        this.handlePasswordChange = (password) => this.onTextChange({ password, invalidPassword: '' });
        this.handleBtnCLick = (e) => {
            const { viewType } = this.props;
            if (viewType !== LOGIN_PAGE_VIEW) {
                this.props.changeViewHandler({ view: LoginViews.SIGNUP }, e);
            }
        };
        this.handleReactivateClick = (userName, isUserNameDigitsOnly) => (e) => {
            e.preventDefault();
            const { pageType, loginSource } = this.props;
            const isUserNameValid = isUserNameDigitsOnly ? isValidMobileNumber(userName) : isValidEmail(userName);
            if (!userName || !isUserNameValid) {
                this.props.trackOmniture((userName || '').length > 0 ? 'invalid_email_mobile' : '', {
                    pageType,
                    loginSource,
                    loginId: getOmnitureLoginId(userName)
                });
                this.setState({
                    credentialError: <StringWidget strKey="loginInvalidUserName"/>
                });
                return false;
            }
            return this.onForgotPasswordClick(userName, e);
        };
        this.state = {
            userName: get(props, ['extra', 'userName']) || '',
            password: get(props, ['extra', 'password']) || '',
            reactivate: get(props, ['extra', 'reactivate']) || false,
            disableOTPButton: get(props, ['extra', 'disableOTPButton']) || false
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (get(nextProps, ['extra', 'userName'])) {
            this.setState({ userName: nextProps.extra.userName, reactivate: false });
        }
        else {
            this.setState({ userName: '', password: '', credentialError: '', invalidPassword: '', reactivate: false });
        }
    }
    render() {
        const { userName, credentialError, invalidPassword, password, reactivate } = this.state;
        const { extra, styles, compactView } = this.props;
        const isUserNameDigitsOnly = isDigitsOnly(userName);
        const preCheck = /^\d{1,10}$/.test(userName);
        return (<form key="loginForm" onSubmit={this.handleSubmit} autoComplete="on" data-aid="LoginForm">
				<TextInput captureAutoFill autoFocus={!compactView} prependInfo={preCheck} value={userName} readOnly={reactivate || compactView} errorMsg={credentialError} placeholder={<StringWidget strKey="loginPlaceHolderUserName"/>} onTextChange={this.handleUserNameChange} className={styles['form-input']} wrapperClass={cx(styles['form-input-wrap'], { [styles['has-error']]: !!credentialError })} appendInfo={compactView}>
					{preCheck ? <span className={styles['prepend-txt']}>+91</span> : null}
					{compactView ? (<a className={cx(styles['append-txt'], styles['input-action-txt'])} onClick={this.handleChangeUserNameClick} tabIndex={-1}>
							<StringWidget strKey="loginChangeUserNameTxt"/>
						</a>) : null}
				</TextInput>
				<TextInput captureAutoFill type="password" autoFocus={compactView} value={password} errorMsg={invalidPassword} placeholder={<StringWidget strKey="loginPlaceHolderPassword"/>} appendInfo="true" onTextChange={this.handlePasswordChange} className={styles['form-input']} wrapperClass={styles['form-input-wrap']}>
					{!reactivate ? (<a className={cx(styles['append-txt'], styles['input-action-txt'])} onClick={this.handleReactivateClick(userName, isUserNameDigitsOnly)} tabIndex={-1}>
							<StringWidget strKey="loginForgotTxt"/>
						</a>) : null}
				</TextInput>
				<div className={styles['terms-text']}>
					By continuing, you agree to Flipkart's{' '}
					<Link to={'/pages/terms'} className={styles['terms-color']} target={'_blank'}>
						Terms of Use
					</Link>{' '}
					and{' '}
					<Link to={'/pages/privacypolicy'} className={styles['terms-color']} target={'_blank'}>
						Privacy Policy
					</Link>
					.
				</div>
				
				<div ref={this.submitContainerRef} className={styles['form-btn-wrap']}>
					<Button type="submit" secondary className={styles['submit-btn']}>
						<Loader stroke="#fff" className={styles['loader-icon']}/>
						<StringWidget strKey={reactivate ? 'loginReactivateBtnTxt' : 'loginTitleTxt'}/>
					</Button>
				</div>

				
				{!extra.disableOTPButton && !compactView && !reactivate && (<div className={styles['login-otp-container']}>
						<div className={styles['login-otp-text']}>{stringTemplate('or')}</div>
						<Button className={cx(styles['submit-btn'], styles['white-btn'])} onClick={this.handleLoginWithOTP}>
							{stringTemplate('loginOTPTitle')}
						</Button>
					</div>)}

				
				{reactivate || compactView ? null : (<div className={styles['login-new-user']}>
						<Button link href={SIGNUP_URL} onClick={this.handleBtnCLick}>
							{stringTemplate('loginWithOTPNewUser')}
						</Button>
					</div>)}
			</form>);
    }
}
LoginView.defaultProps = {
    extra: {},
    trackOmniture: () => null
};
